
declare module "react-widgets" {
  function setDateLocalizer(localizer: any): void;
  function setNumberLocalizer(localizer: any): void;
}

import { setDateLocalizer } from "react-widgets"
import * as moment from "moment" //jalaali

import * as ConfigureReactWidgets from "@framework/ConfigureReactWidgets"
import * as ReactWidgets from 'react-widgets';

export function configure() {
  moment.loadPersian();
  ConfigureReactWidgets.asumeGlobalUtcMode(moment, false);
  //ConfigureReactWidgets.configure();
  monkeyPatchWidgets();
  configureWebpackLocalizer();
}
function globalIsPersian() {
  return moment.locale() == "fa";
}

let da: any = require("date-arithmetic");
function monkeyPatchWidgets() {
  da.year = createAccessor("year", "jYear");
  da.month = createAccessor("month", "jMonth");
  da.date = createAccessor("date", "jDate");

  function createAccessor(method: string, jMethod: string) {
    return (date: any, val: any): any => {
      var unit = globalIsPersian() ? jMethod : method;

      if (val === undefined)
        return (moment(date) as any)[unit]();

      return (moment(date) as any)[unit](val).toDate();
    }
  }
  var oldMonthsInAYear = da.monthsInYear;
  da.monthsInYear = function newMonthsInYear(year: number) {
    if (globalIsPersian()) {
      var months = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
        date = moment(year + '/1/1', 'jYYYY/jMM/jDD').toDate();

      return months.map(function (i) {
        return da.month(date, i);
      });
    }
    else
      return oldMonthsInAYear(year);
  };
}

function configureWebpackLocalizer() {

  if (typeof moment !== 'function') throw new TypeError('You must provide a valid moment object');

  const localField = typeof moment().locale === 'function' ? 'locale' : 'lang',
    hasLocaleData = !!moment.localeData;

  if (!hasLocaleData) throw new TypeError('The Moment localizer depends on the `localeData` api, please provide a moment object v2.2.0 or higher');

  function getMoment(culture: string, value: any, format: string | undefined) {
    return culture ? (moment(value, format) as any)[localField](culture) : moment(value, format);
  }

  function isPersian(culture: string) {
    return culture == undefined ? globalIsPersian() : culture == "fa";
  }

  function endOfDecade(date: Date) {
    return moment(date).add(10, 'year').add(-1, 'millisecond').toDate();
  }

  function endOfCentury(date: Date) {
    return moment(date).add(100, 'year').add(-1, 'millisecond').toDate();
  }

  const localizer = {
    formats: {
      date: 'L',
      time: 'LT',
      'default': 'lll',
      header: function header(date: Date, culture: string, localizer: any) {
        return localizer.format(date, isPersian(culture) ? 'jMMMM jYYYY' : 'MMMM YYYY', culture);
      },
      footer: 'LL',
      weekday: 'dd',
      dayOfMonth: function dayOfMonth(date: Date, culture: string, localizer: any) {
        return localizer.format(date, isPersian(culture) ? 'jDD' : 'DD', culture);
      },
      month: function month(date: Date, culture: string, localizer: any) {
        return localizer.format(date, isPersian(culture) ? 'jMMMM' : 'MMM', culture);
      },
      year: function year(date: Date, culture: string, localizer: any) {
        return localizer.format(date, isPersian(culture) ? 'jYYYY' : 'YYYY', culture);
      },
      decade: function decade(date: Date, culture: string, localizer: any) {
        var yyyy = isPersian(culture) ? 'jYYYY' : 'YYYY';
        return localizer.format(date, yyyy, culture) + ' - ' + localizer.format(endOfDecade(date), yyyy, culture);
      },

      century: function century(date: Date, culture: string, localizer: any) {
        var yyyy = isPersian(culture) ? 'jYYYY' : 'YYYY';
        return localizer.format(date, yyyy, culture) + ' - ' + localizer.format(endOfCentury(date), yyyy, culture);
      }
    },

    firstOfWeek: function firstOfWeek(culture: string) {
      return (moment.localeData(culture) as any).firstDayOfWeek();
    },

    parse: function parse(value: any, format: string, culture: string) {
      if (value == null || value == "")
        return null;

      var moment = getMoment(culture, value, format);
      if (moment.isValid())
        return moment.toDate();

      return undefined;
    },

    format: function format(value: any, _format: string, culture: string) {
      if (value == null)
        return "";

      return getMoment(culture, value, undefined).format(_format);
    }
  };

  ReactWidgets.setDateLocalizer(localizer);
}

declare module "moment" {
  interface Moment {
    jYear(y: number): moment.Moment;
    jYear(): number;

    jMonth(M: number): moment.Moment;
    jMonth(M: string): moment.Moment;
    jMonth(): number;

    jDate(d: number): moment.Moment;
    jDate(): number;

    jDayOfYear(): number;
    jDayOfYear(d: number): moment.Moment;

    jWeek(): number;
    jWeek(d: number): moment.Moment;
    jWeekYear(): number;
    jWeekYear(d: number): moment.Moment;
  }


  export function jDaysInMonth(jYear: number, jMonth: number): number;
  export function jIsLeapYear(jYear: number): boolean;
  export function loadPersian(): void;
}
